import React from 'react'

// Simple theme provider for CRA - we'll use Ant Design's built-in theming
export function ThemeProvider({ children }) {
  return <>{children}</>
}
